import FeedbackSuccess from '../../../components/atoms/feedbacks/feedback-success.vue'

export default {
  components: { FeedbackSuccess },
  data() {
    return {
      isInformationMailChecked: true,
      isUsableGiftChecked: true,
      isFollowUserBirthdayChecked: true,
      isBenefitMailChecked: true,
      isWishListLimittMailChecked: true,
      isFeedbackShowable: false,
      message: ''
    }
  },
  mounted() {
    const noticeFeedbackMessage = document.querySelector('#flash_message').value

    if (noticeFeedbackMessage) {
      this.showFeedback(noticeFeedbackMessage)
    }

    const informationMail = document.querySelector(
      '#receive_information_mail'
    ).value

    if (informationMail === 'false') {
      this.isInformationMailChecked = false
    }

    const usableGiftNotification = document.querySelector(
      '#receive_usable_gift_mail'
    ).value

    if (usableGiftNotification === 'false') {
      this.isUsableGiftChecked = false
    }

    const followUserBirthdayNotification = document.querySelector(
      '#receive_follow_user_birthday_mail'
    ).value

    if (followUserBirthdayNotification === 'false') {
      this.isFollowUserBirthdayChecked = false
    }

    const benefitMail = document.querySelector('#receive_benefit_mail').value

    if (benefitMail === 'false') {
      this.isBenefitMailChecked = false
    }

    const wishListLimitMail = document.querySelector(
      '#receive_wish_list_limit_mail'
    ).value

    if (wishListLimitMail === 'false') {
      this.isWishListLimittMailChecked = false
    }
  },
  methods: {
    enterFeedback() {
      setTimeout(() => {
        this.isFeedbackShowable = false
      }, 3000)
    },
    showFeedback(message) {
      this.isFeedbackShowable = true
      this.message = message
    },
    checkInformationMail() {
      this.isInformationMailChecked = !this.isInformationMailChecked
    },
    checkUsableGift() {
      this.isUsableGiftChecked = !this.isUsableGiftChecked
    },
    checkFollowUserBirthday() {
      this.isFollowUserBirthdayChecked = !this.isFollowUserBirthdayChecked
    },
    checkBenefitMail() {
      this.isBenefitMailChecked = !this.isBenefitMailChecked
    },
    checkWishListLimitMail() {
      this.isWishListLimittMailChecked = !this.isWishListLimittMailChecked
    }
  }
}
